import React, { createContext, useState } from "react";

const IncredContext = createContext();

export const IncredProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    MOBILE: "",
    FNAME: "",
    MNAME: "",
    LNAME: "",
    EMAIL:"",
    PAN: "",
    DOB: "",
    GENDER: "",
    PARTNER_REFERENCE: "A77077",
    EMPLOYMENT_TYPE: "",
    EMPLOYMENT: [
      {
        SALARY: {
          NET_MONTHLY: "",
        },
      },
    ],
    ADDRESS: [
      {
        PINCODE: "",
      },
    ],
    PARTNER_DATA: {
      RM_EMAIL: "",
    },
  });

  const updateField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const updateEmployment = (index, field, value) => {
    const updatedEmployment = [...formData.EMPLOYMENT];
    updatedEmployment[index][field] = value;
    setFormData((prev) => ({
      ...prev,
      EMPLOYMENT: updatedEmployment,
    }));
  };

  const updateAddress = (index, field, value) => {
    const updatedAddress = [...formData.ADDRESS];
    updatedAddress[index][field] = value;
    setFormData((prev) => ({
      ...prev,
      ADDRESS: updatedAddress,
    }));
  };

  const updatePartnerData = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      PARTNER_DATA: {
        ...prev.PARTNER_DATA,
        [field]: value,
      },
    }));
  };

  return (
    <IncredContext.Provider
      value={{
        formData,
        updateField,
        updateEmployment,
        updateAddress,
        updatePartnerData,
      }}
    >
      {children}
    </IncredContext.Provider>
  );
};

export default IncredContext;
